import {parseISO, differenceInCalendarDays} from 'date-fns'

const RENEWAL_WARNING_DAYS = 30

export const clearanceTypes = {
  defense: {value: 'defense', label: 'Défense'},
  radiation_protection: {value: 'radiation_protection', label: 'Radioprotection'},
  site_access: {value: 'site_access', label: 'Accès site'},
}

export const clearanceStatuses = {
  valid: {value: 'valid', label: 'Valide', badgeColor: 'success'},
  under_review: {value: 'under_review', label: 'En cours d\'instruction', badgeColor: 'warning'},
  expired: {value: 'expired', label: 'Expirée', badgeColor: 'danger'},
  suspended: {value: 'suspended', label: 'Suspendue', badgeColor: 'danger'},
}

export const defenseLevels = {
  secret: {value: 'secret', label: 'Secret'},
  top_secret: {value: 'top_secret', label: 'Très secret'},
}

export const defenseScopes = {
  france: {value: 'france', label: 'France'},
  nato: {value: 'nato', label: 'OTAN'},
  eu: {value: 'eu', label: 'UE'},
}

export const radiationProtectionCategories = {
  category_a: {value: 'category_a', label: 'Catégorie A'},
  category_b: {value: 'category_b', label: 'Catégorie B'},
}

/**
 * Statut affiché pour une habilitation : identique au statut back, sauf pour une habilitation
 * "valide" dont la date d'expiration approche (< 30 jours), auquel cas on affiche "Valide - à renouveler"
 * plutôt que "Valide", sans que ce statut dérivé ne soit jamais envoyé au back (pas une valeur de l'enum).
 */
export function getDisplayClearanceStatus(clearance) {
  const status = clearanceStatuses[clearance.status]
  if (!status) {
    return null
  }

  if (clearance.status === clearanceStatuses.valid.value && clearance.expires_at) {
    const daysUntilExpiration = differenceInCalendarDays(parseISO(clearance.expires_at), new Date())
    if (daysUntilExpiration >= 0 && daysUntilExpiration <= RENEWAL_WARNING_DAYS) {
      return {value: 'to_renew', label: 'Valide - à renouveler', badgeColor: 'warning'}
    }
  }

  return status
}

/**
 * Libellé d'affichage d'une habilitation, ex. "Secret - France", "Radioprotection - Catégorie B", "Accès site - EDF Civaux"
 */
export function getClearanceLabel(clearance) {
  switch (clearance.type) {
    case clearanceTypes.defense.value:
      return `${defenseLevels[clearance.level]?.label ?? clearance.level} - ${defenseScopes[clearance.scope]?.label ?? clearance.scope}`
    case clearanceTypes.radiation_protection.value:
      return `Radioprotection - ${radiationProtectionCategories[clearance.category]?.label ?? clearance.category}`
    case clearanceTypes.site_access.value:
      return `Accès site - ${clearance.operating_site}`
    default:
      return ''
  }
}
